/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const UPLOAD_VIEWBOX_W = 20;
const UPLOAD_VIEWBOX_H = 16;

const UPLOAD_PATH =
  'M16.4284 4.20671C15.8174 2.80272 14.7629 1.63779 13.4265 0.890438C12.0901 0.143088 10.5455 -0.145456 9.0294 0.0690207C7.51331 0.283498 6.10936 0.989165 5.03269 2.07789C3.95602 3.16661 3.26602 4.57833 3.06844 6.09671C2.11502 6.32503 1.27866 6.89555 0.718173 7.6999C0.157689 8.50426 -0.0878807 9.48644 0.0280989 10.4599C0.144078 11.4334 0.61353 12.3304 1.3473 12.9806C2.08107 13.6307 3.02806 13.9888 4.00844 13.9867C4.27365 13.9867 4.52801 13.8814 4.71554 13.6938C4.90308 13.5063 5.00844 13.2519 5.00844 12.9867C5.00844 12.7215 4.90308 12.4671 4.71554 12.2796C4.52801 12.0921 4.27365 11.9867 4.00844 11.9867C3.478 11.9867 2.96929 11.776 2.59422 11.4009C2.21915 11.0259 2.00844 10.5171 2.00844 9.98671C2.00844 9.45628 2.21915 8.94757 2.59422 8.5725C2.96929 8.19743 3.478 7.98671 4.00844 7.98671C4.27365 7.98671 4.52801 7.88135 4.71554 7.69382C4.90308 7.50628 5.00844 7.25193 5.00844 6.98671C5.01099 5.80399 5.43272 4.66046 6.1987 3.75929C6.96469 2.85813 8.02533 2.25766 9.19218 2.06459C10.359 1.87151 11.5566 2.09832 12.572 2.70472C13.5874 3.31112 14.355 4.25785 14.7384 5.37671C14.7956 5.54855 14.8983 5.70164 15.0357 5.81964C15.1731 5.93765 15.3399 6.01613 15.5184 6.04671C16.1845 6.17258 16.7883 6.52031 17.2315 7.03325C17.6746 7.54618 17.931 8.19407 17.9588 8.87135C17.9867 9.54863 17.7843 10.2154 17.3847 10.7629C16.9852 11.3105 16.4119 11.7066 15.7584 11.8867C15.5012 11.953 15.2808 12.1188 15.1458 12.3476C15.0107 12.5764 14.9721 12.8495 15.0384 13.1067C15.1047 13.364 15.2705 13.5844 15.4993 13.7194C15.7281 13.8544 16.0012 13.893 16.2584 13.8267C17.3108 13.5486 18.2437 12.9347 18.9154 12.0782C19.5872 11.2217 19.961 10.1693 19.9803 9.08098C19.9995 7.99264 19.663 6.92775 19.022 6.04803C18.381 5.16831 17.4703 4.52181 16.4284 4.20671ZM10.7184 6.27671C10.6233 6.18567 10.5112 6.11431 10.3884 6.06671C10.145 5.96669 9.8719 5.96669 9.62844 6.06671C9.50568 6.11431 9.39354 6.18567 9.29844 6.27671L6.29844 9.27671C6.11013 9.46502 6.00434 9.72041 6.00434 9.98671C6.00434 10.253 6.11013 10.5084 6.29844 10.6967C6.48674 10.885 6.74213 10.9908 7.00844 10.9908C7.27474 10.9908 7.53013 10.885 7.71844 10.6967L9.00844 9.39671V14.9867C9.00844 15.2519 9.11379 15.5063 9.30133 15.6938C9.48886 15.8814 9.74322 15.9867 10.0084 15.9867C10.2737 15.9867 10.528 15.8814 10.7155 15.6938C10.9031 15.5063 11.0084 15.2519 11.0084 14.9867V9.39671L12.2984 10.6967C12.3914 10.7904 12.502 10.8648 12.6239 10.9156C12.7457 10.9664 12.8764 10.9925 13.0084 10.9925C13.1404 10.9925 13.2712 10.9664 13.393 10.9156C13.5149 10.8648 13.6255 10.7904 13.7184 10.6967C13.8122 10.6037 13.8866 10.4931 13.9373 10.3713C13.9881 10.2494 14.0142 10.1187 14.0142 9.98671C14.0142 9.8547 13.9881 9.72399 13.9373 9.60213C13.8866 9.48028 13.8122 9.36967 13.7184 9.27671L10.7184 6.27671Z';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Upload cloud + arrow (20×16 viewBox). `size` sets rendered width; height scales to aspect ratio.
 * Pass `aria-label` when the icon conveys meaning without adjacent text.
 */
const UploadIcon = ({
  size = 20,
  fill = 'currentColor',
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  const width = size;
  const height = (size * UPLOAD_VIEWBOX_H) / UPLOAD_VIEWBOX_W;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${UPLOAD_VIEWBOX_W} ${UPLOAD_VIEWBOX_H}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={['ds-icon', className].filter(Boolean).join(' ')}
      aria-hidden={ariaLabel ? undefined : ariaHidden}
      aria-label={ariaLabel || undefined}
      role={ariaLabel ? 'img' : undefined}
      focusable="false"
      {...props}
    >
      <path d={UPLOAD_PATH} fill={fill} />
    </svg>
  );
};

UploadIcon.propTypes = {
  ...iconPropTypes,
  fill: PropTypes.string,
};

export { UploadIcon };
export default UploadIcon;
